module.exports = __webpack_public_path__ + "img/S1051440.38a2d441.jpg";